
export const config_zales = {
  "title": "Bridal Customizer",
  "max_view": 3,
    "view_image_base": "//bridalimages.thepersonalizedbest.com/bridal_image/",
    "options_all": [
      "ud",
      "ds","dctw","dq","uinfo",
      "head","headc","sh","pkb","pkbc",
      "rset","rsetc","rsetl","ren","renl",
      "rmet","hmetc","smetc",
      "rs",
      "er",//"fr",
      "band",
      "bset","bsetc","bsetl","ben","benl",
      "bmet","bmetc",
      "eb1",//"fb1",
      //"eb2","fb2",
      
    ],
    
    "options_ud": {
      "image_base": "button",
      "name": "Diamond",
      "show": false,
      "option_name": "ud",
      "type": "control",
      "css":"ud",
      
      "image_postfix": "",
      "options": [
        {"image": "diamondlist.png", 
        "name": "Need a Diamond",
         "value": "D",
         "effect": [
          {"effect_attr": "show", "option": ["I"],"optionSet": ["dq"],"effect_value": true ,"if_attr": "dq","if_value":["U"]} ,
           {"effect_attr": "show", "optionSet": ["dctw","dq"],"effect_value": true }  ,
         {"effect_attr": "show", "optionSet": ["uinfo"],"effect_value": false }  ,
        ]

      },
        {"image": "diamonduser.png", 
        "name": "Have a Diamond", 
        "value": "U",
        "effect": [ {"effect_attr": "show", "optionSet": ["dctw","dq"],"effect_value": false }  ,
        {"effect_attr": "show", "optionSet": ["uinfo"],"effect_value": true }  ,
       ]

      }
      ]
    },
    "options_ds": {
      "image_base": "shape",
      "name": "Diamond Shape",
      "show": true,
      "option_name": "ds",
      "type": "control",
      "css": "ds",
      "image_postfix": "",
      "options": [
        {"image": "dsr.png", 
        "name": "Round",
         "value": "R",
         "effect": [ 
         {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": true ,"if_attr": "ud","if_value":["D"]} ,
         {"effect_attr": "show", "option": ["T1","TH2"],"optionSet": ["head"],"effect_value": true },
         {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,]

      },
        {"image": "dsp.png", 
        "name": "Princess", 
        "value": "P",
        "effect": [
           {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": true,"if_attr": "ud","if_value":["D"] } ,
        {"effect_attr": "show", "option": ["T1","TH2"],"optionSet": ["head"],"effect_value": true },
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
      ]

      },
        {
          "image": "dsc.png",
          "quality": "",
          "name": "Cushion",
          "value": "C",
          "month": "",
          "effect": [ 
            {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": true ,"if_attr": "ud","if_value":["D"]},
          {"effect_attr": "show", "option": ["T1","TH2"],"optionSet": ["head"],"effect_value": false },
          {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
         ]
        },
        {
          "image": "dso.png",
          "quality": "",
          "name": "Oval",
          "value": "O",
          "month": "",
          "effect": [
             {"effect_attr": "show", "option": ["1.25"],"optionSet": ["dctw"],"effect_value": false ,"if_attr": "ud","if_value":["D"]},
          {"effect_attr": "show", "option": ["T1","TH2"],"optionSet": ["head"],"effect_value": true } ,
          {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true ,"if_attr": "head","if_value":["H1","H2","S1","S2","SS1","SS2","P1","P2","B1"]} ,
          {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": false ,"if_attr": "head","if_value":["T1","TH2"]} ,
        
         ]
        }
      ]
    },
    "options_dctw": {
      "image_base": "ctw",
      "name": "Diamond Carat Weight",
      "show": true,
      "option_name": "dctw",
      "type": "control",
      "css": "ctw",
      "image_postfix": "",
      "options": [
        {
          "image": "0.25.png",
          "name": "1/4 CT.",
          "value": "0.25",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true } ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "head","if_value":["S1","S2","SS1","SS2","P1","P2","B1"]} ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true ,"if_attr": "head","if_value":["H1","H2","T1","TH2"]} ,
        ]

        },
        {
          "image": "0.33.png",
          "name": "1/3 CT.",
          "value": "0.33",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true }  ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "head","if_value":["S1","S2","SS1","SS2","P1","P2","B1"]} ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true ,"if_attr": "head","if_value":["H1","H2","T1","TH2"]} ,
        ]
        },
        {
          "image": "0.5.png",
          "name": "1/2 CT.",
          "value": "0.5",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true } ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true } ,
        ]
        },
        {
          "image": "0.75.png",
          "name": "3/4 CT.",
          "value": "0.75",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true } ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true } ,
        ]
        },
        {
          "image": "1.png",
          "name": "1 CT.",
          "value": "1",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": true } ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true } ,
        ]
        },
        {
          "image": "1.25.png",
          "name": "1 1/4 CT.",
          "value": "1.25",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": false } ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true } ,]
        },
        {
          "image": "1.5.png",
          "name": "1 1/2 CT.",
          "value": "1.5",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": false } ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true } ,]
        },
        {
          "image": "2.png",
          "name": "2 CT.",
          "value": "2",
          "effect": [ {"effect_attr": "show", "option": ["H2"],"optionSet": ["head"],"effect_value": false } ,
          {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true } ,]
        }
      ]
    },
    "options_dq": {
      "image_base": "qual6",
      "name": "Diamond Quality",
      "show": true,
      "option_name": "dq",
      "type": "select",
      "css": "dq",
      "image_postfix": "",
      "options": [
        { "image": "good.png", "quality": "", "name": "", "value": "I" },
        { "image": "better.png", "quality": "", "name": "", "value": "SI" },
        { "image": "best.png", "quality": "", "name": "", "value": "VS" }
      ]
    },
    "options_head": {
      "image_base": "heads6",
      "name": "Ring Head",
      "show": true,
      "option_name": "head",
      "type": "control",
      "css":"heads",
      "image_postfix": "ds",
      "options": [
       
        {"image": "H1-NA.png","quality": "","name": "Single Halo", "value": "H1",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }  ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
      ]
        },
        {"image": "S1-NA.png","quality": "","name": "4 Prongs", "value": "S1",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }  ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
      ]
        },
        {"image": "P1-NA.png","quality": "4 Prong","name": "Peg Head", "value": "P1",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": false } ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
      ]
        },
        {"image": "S2-NA.png","quality": "4 Double","name": "Tip Prongs", "value": "S2",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": false },
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }   ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
      ]
        },
        {"image": "T1.png","quality": "","name": "3 Stones", "value": "T1",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }  ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": false,"if_attr": "ds","if_value":["O"]} ,
      ]
        },
        {"image": "SS1-NA.png","quality": "4 Prongs","name": "Round", "value": "SS1",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }   ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
      ]
        },
        {"image": "SS2-NA.png","quality": "4 Prongs","name": "Pave", "value": "SS2",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }   ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
        ]
        },
        {"image": "P2-NA.png","quality": "","name": "Peg Head", "value": "P2",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": false }  ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": false }  ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
        
        ]
        },
        {"image": "H2-NA.png","quality": "","name": "Double Halo", "value": "H2",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }  ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
        ]
        },
        {"image": "TH2.png","quality": "3 Stones","name": "Center Halo", "value": "TH2",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }  ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": true ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": false,"if_attr": "ds","if_value":["O"]} ,
        ]
        },
        {"image": "B1-NA.png","quality": "","name": "Bezel", "value": "B1",
        "effect": [ {"effect_attr": "show", "optionSet": ["headc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true }   ,
        {"effect_attr": "show", "option": ["2"],"optionSet": ["sh"],"effect_value": false ,"if_attr": "dctw","if_value":["0.25","0.33"]} ,
        {"effect_attr": "show", "option": ["BDI"],"optionSet": ["headc"],"effect_value": true} ,
        ]
        },
        
      ]
    },
    "options_rs": {
      "image_base": "rs",
      "name": "Ring Size",
      "show": true,
      "option_name": "size",
      "type": "select",
      "css":"rs",
      "image_postfix": "",
      "options": [
        {
          "image": "4.png",
          "name": "",
          "value": "4"
        },
        {
          "image": "45.png",
          "name": "",
          "value": "4.5"
        },
        {
          "image": "5.png",
          "name": "",
          "value": "5"
        },
        {
          "image": "55.png",
          "name": "",
          "value": "5.5"
        },
        {
          "image": "6.png",
          "name": "",
          "value": "6"
        },
        {
          "image": "65.png",
          "name": "",
          "value": "6.5"
        },
        {
          "image": "7.png",
          "name": "",
          "value": "7"
        },
        {
          "image": "75.png",
          "name": "",
          "value": "7.5"
        },
        {
          "image": "8.png",
          "name": "",
          "value": "8"
        },
        {
          "image": "85.png",
          "name": "",
          "value": "8.5"
        },
        {
          "image": "9.png",
          "name": "",
          "value": "9"
        }
      ],
      "attr": "rs"
    },

    "options_rmet": {
      "image_base": "metals6",
      "name": "Metal",
      "show": true,
      "option_name": "rmet",
      "type": "control",
      "css":"line1",
      "image_postfix": "",
      "options": [
        {
          "image": "10.png",
          "name": "Gold",
          "value": "10",
          "effect": [ 
            {"effect_attr": "show", "optionSet": ["hmetc","smetc"],"effect_value": true },
            {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true,"if_attr": "head","if_value":["H1","H2","S1","S2","SS1","SS2","T1","TH2","B1"] },
            {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": false,"if_attr": "head","if_value":["P1","P2"] },
          ]
          
        },
        {
          "image": "14.png",
          "name": "Gold",
          "value": "14",
          "effect": [ 
            {"effect_attr": "show", "optionSet": ["hmetc","smetc"],"effect_value": true },
            {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true,"if_attr": "head","if_value":["H1","H2","S1","S2","SS1","SS2","T1","TH2","B1"] },
            {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": false,"if_attr": "head","if_value":["P1","P2"] },
          ]
          
        },
        {
          "image": "18.png",
          "name": "Gold",
          "value": "18",
          "effect": [ 
            {"effect_attr": "show", "optionSet": ["hmetc","smetc"],"effect_value": true },
            {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": true,"if_attr": "head","if_value":["H1","H2","S1","S2","SS1","SS2","T1","TH2","B1"] },
            {"effect_attr": "show", "optionSet": ["hmetc"],"effect_value": false,"if_attr": "head","if_value":["P1","P2"] },
          ]
          
        },
        {
          "image": "PT.png",
          "name": "Platinum",
          "value": "PT",
          "effect": [ {"effect_attr": "show", "optionSet": ["hmetc","smetc"],"effect_value": false } ]
          
        }
      ]
    },
    "options_bmet": {
      "image_base": "metals6",
      "name": "Band Metal",
      "show": false,
      "option_name": "bmet",
      "css":"line1",
      "type": "control",
      "image_postfix": "",
      "options": [
        {
          "image": "10.png",
          "name": "Gold",
          "value": "10",
          "effect": [ {"effect_attr": "show", "optionSet": ["bmetc"],"effect_value": true,"if_attr": "band","if_value":["C","S"] } ]
          
        },
        {
          "image": "14.png",
          "name": "Gold",
          "value": "14",
          "effect": [ {"effect_attr": "show", "optionSet": ["bmetc"],"effect_value": true,"if_attr": "band","if_value":["C","S"] } ]
          
        },
        {
          "image": "18.png",
          "name": "Gold",
          "value": "18",
          "effect": [ {"effect_attr": "show", "optionSet": ["bmetc"],"effect_value": true,"if_attr": "band","if_value":["C","S"] } ]
          
        },
        {
          "image": "PT.png",
          "name": "Platinum",
          "value": "PT",
          "effect": [ {"effect_attr": "show", "optionSet": ["bmetc"],"effect_value": false } ]
          
        }
      ]
    },
    "options_hmetc": {
      "image_base": "metalcolors6",
      "name": "Ring Head Color",
      "show": true,
      "css":"line1",
      "option_name": "hmetc",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "W.png",
          "name": "White Gold",
          "value": "W"
        },
        {
          "image": "Y.png",
          "name": "Yellow Gold",
          "value": "Y"
        },
        {
          "image": "R.png",
          "name": "Rose Gold",
          "value": "R"
        }
      ]
    },
    "options_smetc": {
      "image_base": "metalcolors6",
      "name": "Mounting Color",
      "show": true,
      "css":"line1",
      "option_name": "smetc",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "W.png",
          "name": "White Gold",
          "value": "W"
        },
        {
          "image": "Y.png",
          "name": "Yellow Gold",
          "value": "Y"
        },
        {
          "image": "R.png",
          "name": "Rose Gold",
          "value": "R"
        }
      ]
    },
    "options_bmetc": {
      "image_base": "metalcolors6",
      "name": "Band Metal Color",
      "show": false,
      "option_name": "bmetc",
      "css":"line1",
      
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "W.png",
          "name": "White Gold",
          "value": "W"
        },
        {
          "image": "Y.png",
          "name": "Yellow Gold",
          "value": "Y"
        },
        {
          "image": "R.png",
          "name": "Rose Gold",
          "value": "R"
        }
      ]
    },
    "options_headc": {
      "image_base": "stones6",
      "name": "Head Stones",
      "show": false,
      "option_name": "headc",
      "css":"singlestone",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "d.png",
          "name": "Diamond",
          "value": "D"
        },
        {
          "image": "sa.png",
          "name": "Sapphire",
          "value": "SA"
        },
        {
          "image": "bd.png",
          "name": "Black Diamond",
          "value": "BDI"
        }
      ]
    },
    "options_rsetc": {
      "image_base": "shankgems",
      "name": "Side Stones",
      "show": false,
      "attr":"rsetc",
      "css":"shankgems",
      "option_name": "rsetc",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "d.png",
          "name": "Diamond",
          "value": "D"
        },
        {
          "image": "sa.png",
          "name": "Sapphire",
          "value": "SA"
        },
        {
          "image": "bd.png",
          "name": "Black Diamond",
          "value": "BDI"
        },
        {
          "image": "sad.png",
          "name": "Alt. Sapphire",
          "value": "SAD"
        },
        {
          "image": "bdid.png",
          "name": "Alt. Black Diamond",
          "value": "BDID"
        }
      ]
    },
    "options_bsetc": {
      "image_base": "shankgems",
      "name": "Band Side Stones",
      "show": false,
      "css":"shankgems",
      "option_name": "bsetc",
      "type": "control",
      "image_postfix": "",
      "options": [
        {
          "image": "d.png",
          "name": "Diamond",
          "value": "D",
          "effect": [   {"effect_attr": "show","option":["3"], "optionSet": ["bsetl"],"effect_value": true },
        ]
        
        },
        {
          "image": "sa.png",
          "name": "Sapphire",
          "value": "SA",
          "effect": [   {"effect_attr": "show","option":["3"], "optionSet": ["bsetl"],"effect_value": true },
        ]
        },
        {
          "image": "bd.png",
          "name": "Black Diamond",
          "value": "BDI",
          "effect": [   {"effect_attr": "show","option":["3"], "optionSet": ["bsetl"],"effect_value": true },
        ]
        },
        {
          "image": "sad.png",
          "name": "Alt. Sapphire",
          "value": "SAD",
          "effect": [   {"effect_attr": "show","option":["3"], "optionSet": ["bsetl"],"effect_value": false },
        ]
        },
        {
          "image": "bdid.png",
          "name": "Alt. Black Diamond",
          "value": "BDID",
          "effect": [   {"effect_attr": "show","option":["3"], "optionSet": ["bsetl"],"effect_value": false },
        ]
        }
      ]
    },
    "options_sh": {
      "image_base": "shank",
      "name": "Mounting",
      "show": true,
      "option_name": "sh",
      "css":"shank",
      "type": "control",
      "image_postfix": "",
      "options": [
        { "image": "1.png","name": "Single", "value": "1" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"  ],"effect_value": true },
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false },
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": true },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": true,"if_attr": "band","if_value":["C","S"] },
      ]
        },
        {  "image": "5.png","name": "Knife Edge", "value": "5" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": false },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": false,"if_attr": "band","if_value":["C","S"] },
      ]
        },
        { "image": "4.png","name": "Double Twist", "value": "4" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": true },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": true,"if_attr": "band","if_value":["C","S"] },
      ]
        },
        {  "image": "7.png","name": "Single Twist", "value": "7" ,
          "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
                      {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": false } ,
                      {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
                      {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false } ,
                      {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": false } ,
                      {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": false },
                      {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
                      {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": false,"if_attr": "band","if_value":["C","S"] },
                    ]
        
        },
        { "image": "2.png", "name": "Double", "value": "2" ,
            "effect": [ {"effect_attr": "show", "optionSet": ["pkb"],"effect_value": true } ,
            {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true }  ,
            {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
            {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false } ,
            {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": true } ,
            {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": true },
            {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
            {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": true,"if_attr": "band","if_value":["C","S"] },
          ]
        },
        {  "image": "10.png","name": "Tapered", "value": "10" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": true },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": true,"if_attr": "band","if_value":["C","S"] },
      ]
        },
        { "image": "8.png", "name": "Square Edge", "value": "8" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": true },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": true,"if_attr": "band","if_value":["C","S"] },
      ]
        },
        {  "image": "6.png","name": "Knife Edge Tulip", "value": "6" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false },
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": false },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": false },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": false,"if_attr": "band","if_value":["C","S"] },
         
      ]
        },
        {  "image": "11.png","name": "Contemporary", "value": "11" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true },
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": false } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": false } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": true },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": true,"if_attr": "band","if_value":["C","S"] },
      ]
        },
        {  "image": "3.png","name": "Triple", "value": "3" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb","pkbc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["PR"], "optionSet": ["bset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["rset"],"effect_value": true } ,
        {"effect_attr": "show","option":["CHR"], "optionSet": ["bset"],"effect_value": true },
        {"effect_attr": "show","option":["C"], "optionSet": ["band"],"effect_value": true },
        {"effect_attr": "show","optionSet": ["ben","benl"],"effect_value": true,"if_attr": "band","if_value":["C","S"] },
      ]
        },
      /*  {  "image": "12.png","name": "Ever Us Single", "value": "12" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb"],"effect_value": false } ]
        },
        {  "image": "14.png","name": "Ever Us Split", "value": "14" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkb"],"effect_value": false } ]
        },*/
        
      ]
    },
    "options_pkb": {
      "image_base": "pkb6",
      "name": "Peekaboo Shape",
      "show": true,
      "option_name": "pkb",
      "css": "pkb",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "none.png", "name": "None", "value": "0" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkbc"],"effect_value": false } ]
      },
        {"image": "round.png", "name": "Round", "value": "R" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkbc"],"effect_value": true } ]},
        {"image": "princess.png", "name": "Princess", "value": "P" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["pkbc"],"effect_value": true } ]},
        
      ]
    },
    "options_pkbc": {
      "image_base": "stones6",
      "name": "Peekaboo Stone",
      "show": false,
      "css":"singlestone",
      "option_name": "pkbc",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "d.png",
          "name": "Diamond",
          "value": "D"
        },
     /*   {
          "image": "sa.png",
          "name": "Sapphire",
          "value": "SA"
        }, */
        {
          "image": "bd.png",
          "name": "Black Diamond",
          "value": "BDI"
          
        }
      ]
    },
    "options_rset": {
      "image_base": "rset",
      "name": "Side Setting",
      "show": true,
      "option_name": "rset",
      "css": "set",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "0.png", "name": "None", "value": "0" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["rsetl","rsetc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true,"if_attr": "sh","if_value":['1','2','3','4','8','9','10','11']}  ,
        {"effect_attr": "show", "optionSet": ["ben","benl" ],"effect_value": true }
      ]
        },
        {"image": "CHR.png", "name": "Channel", "value": "CHR" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["rsetl","rsetc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true ,"if_attr": "sh","if_value":['1','2','3','4','8','9','10','11']},
        {"effect_attr": "show", "optionSet": ["ben","benl" ],"effect_value": true }
      ]
        },
        {"image": "UP.png", "name": "U-Pave", "value": "UP" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["rsetl","rsetc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ren" ,"renl"],"effect_value": false },
        {"effect_attr": "show", "optionSet": ["ben","benl" ],"effect_value": false }
      ]
        },
        {"image": "BD.png", "name": "Bead", "value": "BD" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["rsetl","rsetc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": true ,"if_attr": "sh","if_value":['1','2','3','4','8','9','10','11']},
        {"effect_attr": "show", "optionSet": ["ben","benl" ],"effect_value": true }
      ]
      
        },
        {"image": "PR.png", "name": "Prong", "value": "PR" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["rsetl","rsetc"],"effect_value": true },
        {"effect_attr": "show", "optionSet": ["ren","renl"],"effect_value": false },
        {"effect_attr": "show", "optionSet": ["ben","benl" ],"effect_value": true }
       ]
        },
        
      ]
    },
    "options_bset": {
      "image_base": "bset",
      "name": "Band Side Setting",
      "show": false,
      "css": "set",
      "option_name": "bset",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "0.png", "name": "None", "value": "0" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["bsetl","bsetc"],"effect_value": false } ,
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": true,"if_attr": "sh","if_value":['1',"2","3","4","8","10","11"]},
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": false,"if_attr": "band","if_value":['0']},
      ]
        },
        {"image": "CHR.png", "name": "Channel", "value": "CHR" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["bsetl","bsetc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": true,"if_attr": "sh","if_value":['1',"2","3","4","8","10","11"]},
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": false,"if_attr": "band","if_value":['0']},
      ]
        },
        {"image": "UP.png", "name": "U-Pave", "value": "UP" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["bsetl","bsetc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": false}
      ]
        },
        {"image": "BD.png", "name": "Bead", "value": "BD" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["bsetl","bsetc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": true,"if_attr": "sh","if_value":['1',"2","3","4","8","10","11"]},
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": false,"if_attr": "band","if_value":['0']},
      ]
        },
        {"image": "PR.png", "name": "Prong", "value": "PR" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["bsetl","bsetc"],"effect_value": true } ,
        {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": false}
      ]
        },
        ]
    },
    "options_bsetl": {
      "image_base": "length6",
      "name": "Band Side Stones Length",
      "show": false,
      "option_name": "bsetl",
      "type": "select",
      "css":"len",
      
      "image_postfix": "",
      "options": [
        {"image": "l0.5.png", "name": "Half", "value": "1" },
        {"image": "l0.75.png", "name": "Three-Quarters", "value": "2" },
        {"image": "l1.0.png", "name": "Full", "value": "3" },
        
      ]
    },
    "options_rsetl": {
      "image_base": "length6",
      "name": "Side Stones Length",
      "show": false,
      "option_name": "rsetl",
      "type": "select",
      "css":"len",
      
      "image_postfix": "",
      "options": [
        {"image": "l0.5.png", "name": "Half", "value": "1" },
        {"image": "l0.75.png", "name": "Three-Quarters", "value": "2" },
        
      ]
    },
    "options_band": {
      "image_base": "band",
      "name": "Matching Band",
      "show": true,
      "option_name": "band",
      "type": "control",
      "image_postfix": "",
      "css":"band",
      "options": [
        {"image": "none.png", "name": "None", "value": "0" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["bset","bsetc","bsetl","ben","benl","bmet","bmetc",'eb1','fb1'],"effect_value": false } ]
      },
        {"image": "contour.png", "name": "Contour", "value": "C" ,
        "effect": [ 
          {"effect_attr": "show", "optionSet": ["bset","bsetc","bsetl","bmet","bmetc",'eb1','fb1'],"effect_value": true },
          {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": true,"if_attr": "sh","if_value":['1',"2","3","4","8","10","11"] }
         ]},
        {"image": "straight.png", "name": "Straight", "value": "S" ,
        "effect": [ 
          {"effect_attr": "show", "optionSet": ["bset","bsetc","bsetl","bmet","bmetc",'eb1','fb1'],"effect_value": true },
          {"effect_attr": "show", "optionSet": ["ben","benl"],"effect_value": true,"if_attr": "sh","if_value":['1',"2","3","4","8","10","11"] }
          ]},
        
      ]
    },
    "options_ren": {
      "image_base": "carving6",
      "name": "Carving",
      "show": true,
      "css":"carv",
      "option_name": "ren",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "c0.png", "name": "Plain", "value": "0" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["renl"],"effect_value": false } ]
        },
        {"image": "c1.png", "name": "Leaf", "value": "1",
        "effect": [ {"effect_attr": "show", "optionSet": ["renl"],"effect_value": true } ]
         },
        {"image": "c2.png", "name": "Scroll", "value": "2" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["renl"],"effect_value": true } ]
         },
        {"image": "c3.png", "name": "Feather", "value": "3" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["renl"],"effect_value": true } ]
         },
      ]
    },
    "options_renl": {
      "image_base": "length6",
      "name": "Carving Length",
      "show": false,
      "option_name": "renl",
      "type": "select",
      "css":"len",
      
      "image_postfix": "",
      "options": [
        {"image": "l0.5.png", "name": "Half", "value": "1" },
        {"image": "l0.75.png", "name": "Three-Quarters", "value": "2" },
     //   {"image": "l1.0.png", "name": "Full", "value": "3" },
      ]
    },
    "options_ben": {
      "image_base": "carving6",
      "name": "Band Carving",
      "show": false,
      "option_name": "ben",
      "css":"carv",
      "type": "control",
      "image_postfix": "",
      "options": [
        {"image": "c0.png", "name": "Plain", "value": "0",
        "effect": [ {"effect_attr": "show", "optionSet": ["benl"],"effect_value": false } ]
          },
        {"image": "c1.png", "name": "Leaf", "value": "1",
        "effect": [ {"effect_attr": "show", "optionSet": ["benl"],"effect_value": true } ]
         },
        {"image": "c2.png", "name": "Scroll", "value": "2" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["benl"],"effect_value": true } ]
         },
        {"image": "c3.png", "name": "Feather", "value": "3" ,
        "effect": [ {"effect_attr": "show", "optionSet": ["benl"],"effect_value": true } ]
         },
      ]
    },
    "options_benl": {
      "image_base": "length6",
      "name": "Band Carving Length",
      "show": false,
      "option_name": "benl",
      "type": "select",
      "css":"len",
      
      "image_postfix": "",
      "options": [
        {"image": "l0.5.png", "name": "Half", "value": "1" },
        {"image": "l0.75.png", "name": "Three-Quarters", "value": "2" },
        {"image": "l1.0.png", "name": "Full", "value": "3" },
      ]
    },
    "options_er": {
      "show": true,
      "type": "input",
      "options": [
        {
          "attr": "er",
          "show": true,
          "init_text": "Message",
          "switch_view": 2,
          "maxLength": "25",
          "name": ""
        }
      ],
      "name": "Ring Engraving","attr":"er",
    },
    
    "options_fr": {
      "image_base": "font",
      "name": "Font",
      "show": true,
      "css":"font",
      "option_name": "fr",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "regular.png",
          "name": "",
          "value": "0"
        },
        {
          "image": "script.png",
          "name": "",
          "value": "1"
        }
      ],
      "attr": "fr"
    },
    "options_eb1": {
      "show": false,
      "type": "input",
      "options": [
        {
          "attr": "eb1",
          "show": true,
          "init_text": "Message",
          "switch_view": 2,
          "maxLength": "25",
          "name": ""
        }
      ],
      "name": "Band Engraving",
      "attr": "eb1",
    },
    
    "options_fb1": {
      "image_base": "font",
      "name": "Band Font",
      "show": true,
      "css":"font",
      
      "option_name": "fb1",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "regular.png",
          "name": "",
          "value": "0"
        },
        {
          "image": "script.png",
          "name": "",
          "value": "1"
        }
      ],
      "attr": "fb1"
    },
    "options_eb2": {
      "show": false,
      "type": "input",
      "options": [
        {
          "attr": "eb2",
          "show": true,
          "init_text": "Message",
          "switch_view": 2,
          "maxLength": "25",
          "name": "Line 1"
        }
      ],
      "name": "Band Engraving",
      "attr": "eb2",
    },
    
    "options_fb2": {
      "image_base": "font",
      "name": "Font",
      "show": false,
      "option_name": "fb2",
      "type": "select",
      "image_postfix": "",
      "options": [
        {
          "image": "regular.png",
          "name": "",
          "value": "0"
        },
        {
          "image": "script.png",
          "name": "",
          "value": "1"
        }
      ],
      "attr": "fb2"
    },
      
    "options_uinfo": {
      "show": false,
      "type": "inputDia",
      "options": [
        {
          "attr": "dct",
          "show": true,
          "init_text": "ctw",
          "type":'input',
          "maxLength": "10",
          "name": "Carat weight (0.23 - 2.58 cw)"
        },
        {
          "attr": "dc",
          "show": true,
          "init_text": "Message",
          "type":'combobox',
          "maxLength": "10",
          "name": "Color",
          "menu":["J","I","H","G","F","E","D"]
        },
        {
          "attr": "dcl",
          "show": true,
          "init_text": "Message",
          "type":'combobox',
          "maxLength": "10",
          "name": "Clarity",
          "menu":["I1","SI2","SI1","VS2","VS1","VVS2","VVS1","IF","FL"]
        },
        {
          "attr": "dl",
          "show": true,
          "init_text": "Message",
          "type":'input',
          "maxLength": "10",
          "name": "Length (3 - 10 mm)"
        },
        {
          "attr": "dw",
          "show": true,
          "init_text": "Message",
          "type":'input',
          "maxLength": "10",
          "name": "Width (3 - 10 mm)"
        },
        {
          "attr": "dd",
          "show": true,
          "init_text": "Message",
          "maxLength": "10",
          "type":'input',
          "name": "Depth (3 - 10 mm)"
        }
      ],
      "name": "DIAMOND INFORMATION  (All fields are required)"
    },
    
  }


// WEBPACK FOOTER //
// ./src/config/zales.js